function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { financeInvoiceListApi, clientInvoiceStatus, clientInvoiceUriApi } from '@/api/enterprise';
import ClipboardJS from 'clipboard';
import { getInvoiceClassName, getInvoiceText, getInvoiceType, selectInvoiceFd } from '@/libs/customer';
import { clientInvoiceDetailApi, clientInvoiceStatusPutApi } from '@/api/client';
import { fileLinkDownLoad } from '@/libs/public';
export default {
  components: {
    oaFromBox: function oaFromBox() {
      return import('@/components/common/oaFromBox');
    },
    examineDialog: function examineDialog() {
      return import('@/views/fd/examine/components/examineDialog');
    },
    invoiceDetails: function invoiceDetails() {
      return import('@/components/invoice/invoiceDetails');
    },
    invoicingDialog: function invoicingDialog() {
      return import('./components/invoicingDialog');
    },
    invoiceView: function invoiceView() {
      return import('@/views/customer/invoice/components/invoiceView');
    }
  },
  props: {
    activeName: {
      type: String,
      default: '1'
    },
    types: {
      type: String | Array,
      default: ''
    }
  },
  data: function data() {
    return {
      invoiceUri: '',
      invoiceId: 0,
      // 发票id
      dialogInvoiceVisible: false,
      dialogFormVisible: false,
      invoicingDialog: {},
      tableData: [],
      where: {
        page: 1,
        status: 1,
        time: '',
        name: '',
        invoiced: '',
        limit: 15,
        from: 1,
        time_field: '',
        types: ''
      },
      loading: false,
      voidId: '',
      // 发票id
      voidDataForm: {
        voidData: ''
      },
      total: 0,
      config: {},
      invoiceData: {},
      search: [{
        field_name: '关键字搜索',
        field_name_en: 'search',
        form_value: 'input'
      }, {
        field_name: '审核状态',
        field_name_en: 'status',
        form_value: 'select',
        data_dict: selectInvoiceFd
      }, {
        field_name: '发票类型',
        field_name_en: 'types',
        form_value: 'select',
        data_dict: [{
          value: '',
          label: this.$t('toptable.all')
        }, {
          value: 1,
          label: this.$t('customer.personalinvoice')
        }, {
          value: 2,
          label: this.$t('customer.enterpriseinvoice')
        }, {
          value: 3,
          label: this.$t('customer.specialinvoice')
        }]
      }, {
        field_name: '时间类型',
        field_name_en: 'time_field',
        form_value: 'select',
        data_dict: [{
          name: '申请日期',
          value: 'time'
        }, {
          name: '开票日期',
          value: 'real_date'
        }]
      }, {
        field_name: '开始日期',
        field_name_end: '结束日期',
        field_name_en: 'time',
        form_value: 'date_picker'
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;
    if (this.activeName != 2) {
      var index = this.search.findIndex(function (val) {
        return val.field_name_en == 'status';
      });
      if (index != -1) {
        this.search.splice(index, 1);
      }
    }
    this.where.status = this.types;
    this.getTableData();
    window.addEventListener('message', function (event) {
      switch (event.data.event) {
        case 'onCancel':
          _this.dialogInvoiceVisible = false;
          _this.invoiceUri = '';
          break;
        case 'onSuccess':
          _this.dialogInvoiceVisible = false;
          _this.invoiceUri = '';
          if (_this.invoiceId) {
            clientInvoiceStatusPutApi(_this.invoiceId, event.data.data);
          }
          break;
      }
    });
  },
  filters: {
    statusTypeFn: function statusTypeFn(val) {
      return getInvoiceText(val);
    },
    bgcFn: function bgcFn(val) {
      return getInvoiceClassName(val);
    },
    titleTypeFn: function titleTypeFn(val) {
      return getInvoiceType(val);
    }
  },
  methods: {
    handleInvoicUri: function handleInvoicUri(item) {
      var _this2 = this;
      if (!item.id) {
        return this.$message.error('缺少发票记录ID');
      }
      this.invoiceId = item.id;
      clientInvoiceUriApi(item.id).then(function (res) {
        if (res.status === 400) {
          _this2.$message.error(res.msg);
        } else {
          _this2.dialogInvoiceVisible = true;
          _this2.invoiceUri = res.data.uri;
        }
      });
    },
    // 下载
    handleDown: function handleDown(item) {
      var _this3 = this;
      clientInvoiceDetailApi(item.id).then(function (res) {
        if (res.data.attach) {
          fileLinkDownLoad(res.data.attach, '发票详情');
        } else {
          _this3.$message.error('获取下载地址失败');
        }
      });
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getTableData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.getTableData();
    },
    getStatus: function getStatus(id) {
      var str = '';
      if (id === 0) {
        str = this.$t('customer.audit');
      } else if (id === 1) {
        str = this.$t('customer.passed');
      } else {
        str = this.$t('customer.fail');
      }
      return str;
    },
    // 作废
    voidFn: function voidFn(data) {
      this.voidId = data.id;
      this.dialogFormVisible = true;
      this.voidDataForm.voidData = '';
    },
    getInvoiceType: function getInvoiceType(id) {
      var str = '';
      if (id === 1) {
        str = this.$t('customer.personalinvoice');
      } else if (id === 2) {
        str = this.$t('customer.enterpriseinvoice');
      } else {
        str = this.$t('customer.specialinvoice');
      }
      return str;
    },
    // 获取表格数据
    getTableData: function getTableData() {
      var _this4 = this;
      this.loading = true;
      financeInvoiceListApi(this.where).then(function (res) {
        _this4.loading = false;
        _this4.tableData = res.data.list;
        _this4.total = res.data.count;
      });
    },
    // 开票
    handleInvoicing: function handleInvoicing(row) {
      this.invoicingDialog = {
        title: '开票审核',
        data: row
      };
      this.$refs.invoicingDialog.openBox();
    },
    // c查看
    handleCheck: function handleCheck(item) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this5.invoiceData = {
                title: '发票查看',
                width: '1000px',
                data: item,
                follType: 'fd'
              };
              if (item.link_id == 0) {
                _this5.$refs.invoiceView.openBox(item.link_id);
              } else {
                _this5.$refs.invoiceDetailsView.openBox(item.link_id);
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    submit: function submit() {
      var _this6 = this;
      var data = {
        invalid: 2,
        remark: this.voidDataForm.voidData
      };
      this.$refs.voidData.validate(function (valid) {
        if (valid) {
          clientInvoiceStatus(_this6.voidId, data).then(function (res) {
            _this6.dialogFormVisible = false;
            _this6.form = {};
            _this6.getTableData();
          });
        }
      });
    },
    // 发票审核
    handleEdit: function handleEdit(item, type) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (type === 1) {
                _this7.config = {
                  title: '作废审核',
                  width: '480px',
                  type: 2,
                  data: item
                };
                _this7.$refs.examineDialog.handleOpen();
              } else {
                _this7.config = {
                  title: _this7.$t('customer.invoicereview'),
                  width: '480px',
                  type: 2,
                  data: item
                };
                _this7.$refs.examineDialog.handleOpen();
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    confirmData: function confirmData(data) {
      if (data == 'reset') {
        this.where = {
          limit: this.where.limit
        };
      } else {
        this.where.types = data.types;
        this.where.time = data.time;
        this.where.time_field = data.time_field;
        this.where.invoiced = data.type;
        this.where.name = data.search;
      }
      this.where.page = 1;
      this.where.status = data.status;
      this.getTableData();
    },
    isOk: function isOk() {
      this.getTableData();
    },
    copy: function copy() {
      var _this8 = this;
      this.$nextTick(function () {
        var clipboard = new ClipboardJS('.copy');
        clipboard.on('success', function () {
          _this8.$message.success(_this8.$t('setting.copytitle'));
          clipboard.destroy();
        });
        _this8.$store.commit('app/SET_CLICK_TAB', false);
      });
    }
  }
};